import React, { useState } from 'react';
import { useRouter } from 'hooks/use-router';
import { Layout } from './user-activity-log-detail.styled';
import useAppBarTitle from 'hooks/use-app-bar-title';
import { Divider, Grid } from '@material-ui/core';
import PageHeader from 'components/layout/page-header/page-header';
import { Root } from '../user-activity-log-list/user-activity-log-list.styled';
import useUserActivityLogDetail from '../../hooks/use-user-activity-log-detail';
import { TGetUserActivityLogDetailResponse } from 'types/entities/user-activity-logs';
import {
    Box,
    BoxContent,
    BoxTitle,
} from 'components/layout/box/custom-box.styled';
import { toSentenceCaseFormat } from 'utils/sentence-case-format';
import { ERoutesPrivate, ERoutesType, routes } from 'types/routes';
import timeFormat from 'utils/time-format';

type TUserDetail = {};
type TUserActivityLogDetailQuery = {
    id: string;
};

const pageTitle = 'User Activity Log Details';

const UserActivityLogDetail: React.FC<TUserDetail> = () => {
    useAppBarTitle(pageTitle);
    const { history, query } = useRouter<TUserActivityLogDetailQuery>();

    const [curUserData, setCurUserData] =
        useState<TGetUserActivityLogDetailResponse | null>();

    const { isLoading, isError, error } = useUserActivityLogDetail(query.id, {
        onSuccess: (data) => {
            setCurUserData(data as TGetUserActivityLogDetailResponse);
        },
    });

    const handleUserClick = (userId: string) => {
        history.push(
            `${routes[ERoutesType.Private][ERoutesPrivate.Users][0]}/${userId}`,
        );
    };

    if (isLoading) {
        return <>Loading</>;
    }

    if (isError || !curUserData) {
        return <>{error}</>;
    }

    return (
        <Root>
            <Layout>
                <PageHeader />
                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <Box>
                            <BoxTitle>User Activity Log</BoxTitle>
                            <BoxContent>
                                <div>
                                    <span>Log ID</span>
                                    <span>{curUserData.id}</span>
                                </div>
                                <Divider />
                                <div>
                                    <span>Action Type</span>
                                    <span>
                                        {toSentenceCaseFormat(
                                            curUserData.actionType,
                                        )}
                                    </span>
                                </div>
                                <Divider />
                                <div>
                                    <span>User ID</span>
                                    <span>{curUserData.userId || '-'}</span>
                                </div>
                                <Divider />
                                <div>
                                    <span>User Nex Tag</span>
                                    <span>
                                        {curUserData.nexId
                                            ? `@${curUserData.nexId}`
                                            : '-'}
                                    </span>
                                </div>
                                <Divider />
                                <div>
                                    <span>Device ID</span>
                                    <span>{curUserData.deviceId || '-'}</span>
                                </div>
                                <Divider />
                                <div>
                                    <span>Created At</span>
                                    <span>
                                        {timeFormat(curUserData.createdAt) ||
                                            '-'}
                                    </span>
                                </div>
                                <Divider />
                                {curUserData.details.map((detail) => {
                                    return (
                                        <>
                                            <div>
                                                <span>
                                                    {toSentenceCaseFormat(
                                                        detail.name,
                                                    )}
                                                </span>
                                                <span>{detail.value}</span>
                                            </div>
                                            <Divider />
                                        </>
                                    );
                                })}
                            </BoxContent>
                        </Box>
                    </Grid>
                </Grid>
            </Layout>
        </Root>
    );
};

export default UserActivityLogDetail;
